module.exports = __webpack_public_path__ + "static/img/kepco-cs.2fbf448.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/kepco-cs.jpg
// module id = iEcZ
// module chunks = 0